import React from 'react';
import Field from '../Field';
import Select from '../Select';

export default props => (
  <Field {...props}>
    <Select />
  </Field>
);
